import { useState } from 'react';
import logo from '../../assets/images/logo.png';
import Button from '../ui/Button';
import menuicon from '../../assets/images/menu.svg'
import closeicon from '../../assets/images/close.svg'

import { useSmoothScroll } from '../../hooks/useSmoothScroll';


function MenuIcon({ onClick }: { onClick: () => void }) {
  return (
    <button
      className="md:hidden flex items-center justify-center p-2 rounded focus:outline-none"
      aria-label="Open menu"
      onClick={onClick}
      type="button"
    >
     <img src={menuicon} alt="Menu" className="h-8 w-auto" />
    </button>
  );
}

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { scrollToSection } = useSmoothScroll();

  const closeSidebar = () => setSidebarOpen(false);

  const handleNavClick = (sectionId: string) => {
    scrollToSection(sectionId);
    closeSidebar();
  };
  const handleDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
        "_blank",
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open("https://apps.apple.com/app/speedyssey", "_blank");
    } else {
      // Desktop fallback
      window.open(
        "https://play.google.com/store/apps/details?id=com.dp.speedyssey",
        "_blank",
      );
    }
  };
  return (
    <header className="w-full bg-white sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center px-6 lg:px-12 py-4">
        {/* Logo */}
        <button 
          onClick={() => scrollToSection('overview')} 
          className="flex items-center gap-2 hover:opacity-80 transition-opacity"
        >
          <img src={logo} alt="Speedyssey Logo" className="h-8 w-auto" />
          <span className="font-bold text-xl antonio">Speedyssey</span>
        </button>

        {/* Navigation (desktop) */}
        <nav className="hidden md:flex items-center gap-8 font-medium text-gray-700">
          <button onClick={() => scrollToSection('overview')} className="hover:text-[#F55109] transition-colors">Overview</button>
          <button onClick={() => scrollToSection('how')} className="hover:text-[#F55109] transition-colors">How it Works</button>
          <button onClick={() => scrollToSection('requirements')} className="hover:text-[#F55109] transition-colors">Requirements</button>
          <button onClick={() => scrollToSection('faqs')} className="hover:text-[#F55109] transition-colors">FAQs</button>
        </nav>

        {/* CTA (desktop) */}
        <div className="hidden md:block ">
          <Button
            title="Download App"
            variant="secondary"
              size="md"
              onClick={handleDownload}
          />
        </div>

        {/* Hamburger menu (mobile) */}
        <MenuIcon onClick={() => setSidebarOpen(true)} />
      </div>

      {/* Sidebar overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black/40 transition-opacity duration-300 ${
          sidebarOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={closeSidebar}
        aria-hidden={!sidebarOpen}
      />

      {/* Sidebar (reduced height, no logo or horizontal rule, centered button) */}
      <aside
        className={`fixed top-0 right-0 z-50 h-[40vh] w-64 bg-white shadow-lg rounded-bl-2xl transform transition-transform duration-300
        ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'}
        flex flex-col`}
        aria-hidden={!sidebarOpen}
      >
        <div className="flex justify-end px-6 py-4">
          <button
            className="p-2 rounded focus:outline-none mr-4"
            aria-label="Close menu"
            onClick={closeSidebar}
            type="button"
          >
           <img src={closeicon} alt="Close" className="h-8 w-auto" />
          </button>
        </div>
        <nav className="flex flex-col gap-6 px-6 py-4 text-base font-medium text-gray-700">
          <button onClick={() => handleNavClick('overview')} className="hover:text-[#F55109] transition-colors text-left">Overview</button>
          <button onClick={() => handleNavClick('how')} className="hover:text-[#F55109] transition-colors text-left">How it Works</button>
          <button onClick={() => handleNavClick('requirements')} className="hover:text-[#F55109] transition-colors text-left">Requirements</button>
          <button onClick={() => handleNavClick('faqs')} className="hover:text-[#F55109] transition-colors text-left">FAQs</button>
        </nav>
        <div className="flex justify-center items-center px-6 mt-auto pb-8">
          {/* <Button
            title="Download App"
            variant="secondary"
            size="lg"
            className="w-full max-w-xs mx-auto mr-4 flex justify-center items-center text-center"
            onClick={() => {
              window.open('https://example.com', '_blank');
              closeSidebar();
            }}
          /> */}
        </div>
      </aside>
    </header>
  );
}

export default Header;
